module.exports = __webpack_public_path__ + "static/media/SB.2c5f9dc8.png";